import React, { useState } from 'react'

import { AppBar, Link, Drawer, Divider, ClickAwayListener, Popper, Paper, ListItem, List, Stack, Typography, Button, Collapse, ListItemButton, ListItemText, useMediaQuery } from '@mui/material';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import MenuIcon from '@mui/icons-material/Menu';

import AccountIcon from '@mui/icons-material/AccountCircleOutlined';
import style from "../utils/style"

//svg imports

import { ReactComponent as LogoIcon } from "../assets/svg/logo.svg"
export default function Header(props) {
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const matches = useMediaQuery('(max-width:800px)');
  const fullScreen = useMediaQuery('(min-width:1014px)');

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const [collectMenu, setCollectMenu] = useState(false);
  const [serviceMenu, setServiceMenu] = useState(false);

  const [menu, setMenu] = useState(false);
  const [anchorEl, setAnchorEl] = useState();
  const [service, setService] = useState(false);
  const [serviceAnchor, setServiceAnchor] = useState();
  const handleOpen = (event) => {
    setAnchorEl(event.currentTarget);
    setMenu((prev) => !prev);
    setCollectMenu((prev) => !prev);
  };
  const handleService = (event) => {
    setServiceAnchor(event.currentTarget);
    setService((prev) => !prev);
    setServiceMenu((prev) => !prev)
  };
  const id = menu ? 'simple-popper' : undefined;
  const serveID = service ? 'simple-popper' : undefined;

  const handleMenu = () => {
    setMenu(false);
    setService(false);
  };
  const divider = (
    <Divider sx={style.dividerLine} variant="middle" />
  )

  const drawer = (
    <Box>
       {!fullScreen &&
        <Stack direction="row" alignItems="center" justifyContent="center">
          <Link href="/profile" sx={{ textTransform: "none" }}>
            <IconButton sx={style.linkTexts}>
              <AccountIcon sx={{ height: 80, width: 80 }} />
            </IconButton>
          </Link>
        </Stack>}
      <Link href="/about" sx={{ textDecoration: "none" }}>
        <Button disableRipple sx={style.linkTexts}>
          About
        </Button>
      </Link>
      {divider}
      <Button disableRipple onClick={handleService} sx={style.linkTexts}>
        Services
      </Button>
      {matches && <Collapse in={serviceMenu} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Link href="/services" sx={style.linkTexts}>
            <ListItemButton sx={{ pl: 3 }}>
              <ListItemText primary="Book Reservation" />
            </ListItemButton>
          </Link>
          <Link href="/mobilelibrary" sx={style.linkTexts}>
            <ListItemButton sx={{ pl: 3 }}>
              <ListItemText primary="Mobile Library" />
            </ListItemButton>
          </Link>
        </List>
      </Collapse>}
      {divider}
      <Button disableRipple sx={style.linkTexts} onClick={handleOpen}>
        Collections
      </Button>
      {matches && <Collapse in={collectMenu} timeout="auto" unmountOnExit>
        <List component="div" disablePadding>
          <Link href="/librarycollections" sx={style.linkTexts}>
            <ListItemButton sx={{ pl: 3 }}>
              <ListItemText primary="Library Collections" />
            </ListItemButton>
          </Link>
          <Link href="/ebooks" sx={style.linkTexts}>
            <ListItemButton sx={{ pl: 3 }}>
              <ListItemText primary="E-Books" />
            </ListItemButton>
          </Link>
        </List>
      </Collapse>}
      {divider}
      {fullScreen && <Link href="/mybooks/reserve" sx={{ textTransform: "none" }}>
        <IconButton sx={style.linkTexts}>
          <AccountIcon sx={{ height: 40, width: 40 }} />
        </IconButton>
      </Link>}
    </Box>
  )

  return (
    <Box>
      <AppBar position="static" sx={style.appBar} color="transparent" elevation={0}>
        <Toolbar sx={style.toolBar}>
          <Box sx={style.logo}>
            <LogoIcon id="logoImage" style={{ height: "inherit", width: "inherit", color: "inherit" }} />
          </Box>
          <Box component="span" sx={{ flexGrow: 1 }} />
          <IconButton
            color="inherit"
            aria-label="open drawer"
            edge="start"
            onClick={handleDrawerToggle}
            sx={style.menuButton}
          >
            <MenuIcon />
          </IconButton>
          <Box sx={style.navBar}>
            {drawer}
          </Box>
          <Drawer
            variant="temporary"
            anchor="right"
            PaperProps={{
              sx: { width: "70%" },
            }}
            open={mobileOpen}
            onClose={handleDrawerToggle}
            ModalProps={{
              keepMounted: true // Better open performance on mobile.
            }}
          >
            {drawer}
          </Drawer>
        </Toolbar>
      </AppBar>
      {!matches && <Popper id={id} open={menu} anchorEl={anchorEl}>
        <ClickAwayListener onClickAway={handleMenu}>
          <Paper sx={{ marginBottom: 1, marginRight: 2 }}>
            <List >
              <ListItem button sx={{ display: "flex", justifyContent: "flex-end" }} >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Link href="/librarycollections" sx={{ textDecoration: "none" }}>
                    <Typography sx={{ color: (theme) => theme.palette.text.primary }} >Library Collections</Typography>
                  </Link>
                </Stack>
              </ListItem>
              <ListItem button sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Link href="/ebooks" sx={{ textDecoration: "none" }}>
                    <Typography sx={{ color: (theme) => theme.palette.text.primary }}>E-Books </Typography>
                  </Link>
                </Stack>
              </ListItem>
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>}
      {!matches && <Popper id={serveID} open={service} anchorEl={serviceAnchor}>
        <ClickAwayListener onClickAway={handleMenu}>
          <Paper sx={{ marginBottom: 1, marginRight: 2 }}>
            <List >
              <ListItem button sx={{ display: "flex", justifyContent: "flex-end" }} >
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Link href="/services" sx={{ textDecoration: "none" }}>
                    <Typography sx={{ color: (theme) => theme.palette.text.primary }} >Book Reservation</Typography>
                  </Link>
                </Stack>
              </ListItem>
              <ListItem button sx={{ display: "flex", justifyContent: "flex-end" }}>
                <Stack direction="row" alignItems="center" spacing={1}>
                  <Link href="/mobilelibrary" sx={{ textDecoration: "none" }}>
                    <Typography sx={{ color: (theme) => theme.palette.text.primary }}>Mobile Library</Typography>
                  </Link>
                </Stack>
              </ListItem>
            </List>
          </Paper>
        </ClickAwayListener>
      </Popper>}
    </Box>
  );
}